module.exports = __webpack_public_path__ + "de012d42f37f5858ab6f1ea69750a46d.svg";